var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CelestialQuoteLine',{attrs:{"quote":_vm.quote,"current-line":_vm.currentLine,"left-visible":!_vm.isQuoteStart && _vm.leftVisible,"right-visible":!_vm.isQuoteEnd && _vm.rightVisible,"close-visible":_vm.isQuoteEnd && _vm.closeVisible,"primary":""},on:{"close":_vm.close,"progress-in":_vm.progressIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }